import { PlansRenewalValues } from '@/modules/employer/components/SetupEmployer/SetupEmployer.types';
import { storeCreator } from '@/utils/store/store.utils';

const INIT_STATE = {};

interface State {
  state: PlansRenewalValues;
  setPlansRenewal: (value: PlansRenewalValues) => void;
}

const useStore = storeCreator<State>((set) => ({
  state: INIT_STATE,
  setPlansRenewal: (newState: PlansRenewalValues) => set((oldState) => ({
    state: {
      ...oldState.state,
      ...newState,
    },
  })),
}));

const usePlansRenewalStore = () => ({ ...useStore() });

export default usePlansRenewalStore;
